import React from "react";
import { Text, useMantineTheme, Group } from '@mantine/core';
import { IconArrowNarrowDown, IconArrowNarrowUp } from '@tabler/icons-react';

import { regexNoStriped } from "../../utils/globalFunctions";

const THSort = ({ stateSortSelected, stateSortInUse, fnSort, stateCaptionNoWrap = true, stateCaptionAlign = 'left' }) => {

    const theme = useMantineTheme();
    const selectedInUse = regexNoStriped(stateSortInUse.slug) === regexNoStriped(stateSortSelected.slug);

    return (
        <th
            className="THSort"
            style={{
                cursor: 'pointer',
                backgroundColor: theme.colorScheme === 'light' ? (selectedInUse ? theme.colors.gray[3] : theme.colors.gray[2]) : (selectedInUse ? theme.colors.dark[5] : theme.colors.dark[6]),
                userSelect: 'none',
                whiteSpace: stateCaptionNoWrap ? 'nowrap' : 'normal',
                textAlign: stateCaptionAlign,
                paddingRight: '0px'
            }}

            onClick={() => {
                fnSort(stateSortInUse);
            }}
        >
            <Group position="apart" noWrap pr='sm' className="wrapperContentTH">
                <Text sx={{ width: '100%' }}>{stateSortInUse.caption}</Text>

                {selectedInUse ? ((stateSortSelected.slug)[0] === '-' ?
                    <IconArrowNarrowUp
                        size={20}
                        color="gray"
                    />
                    :
                    <IconArrowNarrowDown
                        size={20}
                        color="gray"
                    />
                )
                    :
                    <IconArrowNarrowDown
                        size={20}
                        color="transparent"
                    />
                }
            </Group>
        </th>
    )
}

export default React.memo(THSort);